<script>
import { Pie } from "vue-chartjs";

export default {
    name: "IpTrafficStatusPieChart",
    extends: Pie,
    props: {
        // 後端回傳：[{ status: "200", count: 123 }, ...]
        statusStats: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        statusStats: {
            immediate: false,
            deep: true,
            handler() {
                this.renderPieChart();
            },
        },
    },
    mounted() {
        this.renderPieChart();
    },
    methods: {
        getStatusColors(statusCount) {
            const defaultColors = [
                "#00b883", // 綠
                "#ff9800", // 橘
                "#f44336", // 紅
                "#1055C9", // 藍
                "#9c27b0", // 紫
                "#FFCC00", // 黃
                "#BF9264", // 咖啡
            ];

            const randomColor = () => {
                const r = Math.floor(100 + Math.random() * 155);
                const g = Math.floor(100 + Math.random() * 155);
                const b = Math.floor(100 + Math.random() * 155);
                return `rgb(${r}, ${g}, ${b})`;
            };

            return Array.from({ length: statusCount }, (_, idx) => {
                return idx < defaultColors.length ? defaultColors[idx] : randomColor();
            });
        },
        renderPieChart() {
            if (!this.statusStats || !this.statusStats.length) return;

            // x 軸 label
            const labels = this.statusStats.map((item) => item.status);

            // y 軸資料
            const data = this.statusStats.map((item) => item.count);

            this.renderChart(
                {
                    labels,
                    datasets: [
                        {
                            label: "Status 分佈",
                            data,
                            backgroundColor: this.getStatusColors(this.statusStats.length),
                        },
                    ],
                },
                {
                    responsive: true,
                    maintainAspectRatio: true, // 保持正圓形
                    aspectRatio: 1, // 正方形 → 圓餅比例固定
                    plugins: {
                        legend: {
                            position: "right",
                        },
                        tooltip: {
                            callbacks: {
                                label(context) {
                                    const label = context.label || "";
                                    const value = context.raw || 0;

                                    const total = data.reduce((acc, cur) => acc + cur, 0);
                                    const percent = total ? ((value / total) * 100).toFixed(1) : 0;

                                    return `${label}: ${value} (${percent}%)`;
                                },
                            },
                        },
                    },
                }
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Chart/IpTrafficStatusPieChart.vue